import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import {
    setBaseLayer
} from '../../../redux/layers/Actions';
import { withStyles, TextField, Typography, FormControlLabel, Checkbox, Collapse } from '@material-ui/core';

// import SpeedDial from './SpeedDial'
import {
    SpeedDial,
    SpeedDialAction,
    SpeedDialIcon
} from '@material-ui/lab';

const MainIcon = () => (
    <div className={`${classes.baseLayerDropdownItem}`}>
        <div className={`${classes.baseLayerDropdownItemImage} ${classes.light}`}>
            <div className={classes.imageOverlay}>
                <Typography
                    variant="subtitle2"
                    component="div"
                    color="textPrimary"
                    className={classes.baseLayerDropdownItemText}
                >
                    Light
                </Typography>
            </div>
        </div>
    </div>
);

class BasemapControl extends React.Component {
    constructor (props) {
        super(props);
        this.getSelectedBasemapImage = this.getSelectedBasemapImage.bind(this);
        this.handleOpen = this.handleOpen.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.state = {
            isOpen: false
        };
    }

    getSelectedBasemapImage (systemName) {
        const { baseLayers, classes } = this.props;
        const baseLayer = baseLayers.find(l => l.system_name === systemName);

        switch (baseLayer.system_name) {
            case 'light':
                return classes.light;
            case 'dark':
                return classes.dark;
            case 'aerial':
                return classes.aerial;
            case 'roads':
                return classes.roads;
            case 'outdoor':
                return classes.outdoor;
            case 'osmmlight':
                return classes.osmmLight;
            case 'osmmstandard+roads':
                return classes.osmmStandard;
            default:
                // console.log(baseLayer.system_name, systemName, baseLayers)
                return null;
        }
    }

    handleOpen (e, reason) {
        if (reason === 'toggle') {
            this.setState({
                isOpen: true
            });
        }
    }

    handleClose (e, reason) {
        if (reason === 'toggle') {
            this.setState({
                isOpen: false
            });
        }
    }


    render () {
        const { classes, baseLayer, baseLayers, dispatchSetBaseLayer } = this.props;
        const { isOpen } = this.state;
        return (
            <div className={classes.root}>
                <SpeedDial
                    direction="left"
                    ariaLabel="Select basemap"
                    className={classes.speedDial}
                    icon={<div className={`${classes.baseLayerDropdownItem}`}>
                        <div style={{
                            backgroundImage: `url('${baseLayer.image_url}')`
                        }}
                        className={`${classes.baseLayerDropdownItemImage}`}>
                            <div className={classes.imageOverlay}>
                                <Typography
                                    variant="subtitle2"
                                    component="div"
                                    color="textPrimary"
                                    className={classes.baseLayerDropdownItemText}
                                >
                                    {baseLayer.name}
                                </Typography>
                            </div>
                        </div>
                    </div>}
                    onClose={this.handleClose}
                    onOpen={this.handleOpen}
                    open={isOpen}
                >
                    { baseLayers.filter(bl => bl.system_name !== baseLayer.system_name).map((bl, i) => {
                        return (<SpeedDialAction
                            key={i}
                            id={i}
                            title={bl.name}
                            TooltipClasses={{
                                popper: classes.hidden
                            }}
                            className={classes.speedDialItem}
                            onClick={() => {
                                dispatchSetBaseLayer(bl.system_name);
                                this.handleClose(null, 'toggle');
                            }}
                            icon={<div className={`${classes.baseLayerDropdownItem}`}>
                                <div className={`${classes.baseLayerDropdownItemImage}`} style={{ backgroundImage: `url('${bl.image_url}')` }}>
                                    <div className={classes.imageOverlay}>
                                        <Typography
                                            variant="subtitle1"
                                            component="div"
                                            color="textPrimary"
                                            className={classes.baseLayerDropdownItemText}
                                        >
                                            {bl.name}
                                        </Typography>
                                    </div>
                                </div>
                            </div>}
                        />);
                    }) }
                </SpeedDial>
            </div>
        );
    }
}

const styles = (theme) => ({
    root: {

    },
    hidden: {
        display: 'none'
    },
    basemapIcon: {
        width: '100px',
        height: '100px',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: 'cover'
    },
    light: {
        backgroundImage: 'url(\'https://landhawk.s3.eu-west-1.amazonaws.com/base-map-icons/Map Tile - Light.png\')'
    },
    aerial: {
        backgroundImage: 'url(\'https://landhawk.s3.eu-west-1.amazonaws.com/base-map-icons/Map Tile - Satellite.png\')'
    },
    dark: {
        backgroundImage: 'url(\'https://landhawk.s3.eu-west-1.amazonaws.com/base-map-icons/Map Tile - Dark.png\')'
    },
    roads: {
        backgroundImage: 'url(\'https://landhawk.s3.eu-west-1.amazonaws.com/base-map-icons/Map Tile - Roads.png\')'
    },
    osmmStandard: {
        backgroundImage: 'url(\'https://landhawk.s3.eu-west-1.amazonaws.com/base-map-icons/Map Tile - OS MasterMap.png\')'
    },
    outdoor: {
        backgroundImage: 'url(\'https://landhawk.s3.eu-west-1.amazonaws.com/base-map-icons/Map Tile - Outdoor.png\')'
    },
    osmmLight: {
        backgroundImage: 'url(\'https://landhawk.s3.eu-west-1.amazonaws.com/base-map-icons/OSMM_Light.png\')'
    },
    speedDial: {
        marginBottom: '10px',
        pointerEvents: 'none !important',
        '& > button': {
            background: 'transparent !important',
            boxShadow: 'none',
            width: 'initial',
            height: 'initial',
            borderRadius: '0px'
        }
    },
    speedDialItem: {
        background: 'transparent !important',
        boxShadow: 'none',
        width: 'initial',
        height: 'initial',
        borderRadius: '0px'
    },
    baseLayerDropdownItem: {
        display: 'flex',
        width: '100%',
        alignItems: 'center',
        justifyContent: 'flex-end',
        cursor: 'pointer',
        transition: '0.1s',
        borderRadius: '6px',
        boxSizing: 'border-box'

    },
    baseLayerDropdownItemImage: {
        height: '100px',
        width: '100px',
        margin: '1px',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        borderRadius: '4px',
        border: `2px solid ${theme.palette.background.contrastText}`
    },
    imageOverlay: {
        display: 'grid',
        alignContent: 'end',
        justifyContent: 'start',
        width: '100%',
        height: '100%',
        background: 'linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(0, 0, 0, 0.5) 100%)',
        borderRadius: '4px'
    },
    baseLayerDropdownItemText: {
        padding: '5px 7px',
        lineHeight: 1,
        alignSelf: 'end',
        letterSpacing: '0.4px',
        textShadow: '0 2px 2px rgb(0, 0, 0, 0.25)',
        fontWeight: '500',
        textAlign: 'left',
        textTransform: 'none'
    }
});

const mapStateToProps = (state) => ({
    baseLayer: state.layers.baseLayer,
    baseLayers: state.layers.baseLayers.filter(bl => bl.selectable)
});

const mapDispatchToProps = (dispatch) => ({
    dispatchSetBaseLayer: (baseLayer) => dispatch(setBaseLayer(baseLayer))
});

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(styles)
)(BasemapControl);